import PaymentCheckoutScreen from '@/modules/payments/components/PaymentCheckoutScreen';

export default PaymentCheckoutScreen;
